export default __webpack_public_path__ + "static/media/worlds.2fd7a3b5.png";